import { Trigger } from '@radix-ui/react-tabs';
import cn from 'classnames';
import styles from './CustomTrigger.module.scss';

interface ICostumeTriggerProps {
  value: string;
  title: string;
  activeTab: string;
  className?: string;
}

const CustomTrigger = ({
  value,
  title,
  activeTab,
  className,
}: ICostumeTriggerProps) => {
  return (
    <Trigger
      key={value}
      value={value}
      className={cn(styles.rootsTrigger, className, {
        [styles.activeTrigger]: activeTab === value,
      })}
    >
      {title}
    </Trigger>
  );
};

export default CustomTrigger;
